import React, {memo, useState, useMemo, useRef, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import OtherAboveFold from '../../components/OtherAboveFold';
import CustomizeTravelBtnOther from '../../components/CustomizeTravelBtnOther';
import PointersCard from '../../components/PointersCard';
import Choose from '../../components/Choose';
import Pointers from '../../components/Pointers';
import ServiceFlow from '../../components/ServiceFlow';
import { isMath, isNormalZhEnCss, getClientRect, delay } from '../../utils';
import  * as TYPES  from '../../models/types';

import styles from './styles.module.scss';

import svgTitle from '../../assets/img/customtravel/banner/titleCustomizedtravel.svg';
import svgTitleM from '../../assets/img/customtravel/banner/titleCustomizedtravelM.svg';
import bannerImg_1 from '../../assets/img/customtravel/banner/customizedtravel_1.jpg';
import bannerImg_2 from '../../assets/img/customtravel/banner/customizedtravel_2.jpg';
import bannerImg_3 from '../../assets/img/customtravel/banner/customizedtravel_3.jpg';
import bannerImg_5 from '../../assets/img/customtravel/banner/customizedtravelm.jpg';
import PlanTravel from '../../components/PlanTravel';

const Index = memo(() => {

  const dispatch = useDispatch();
  const { basicDrawerEvent } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { customTravel, lang } = useSelector(({localesReducer}) => localesReducer.i18n);
  const { scrolVal, scrolFidx } = useSelector(({scrollNumReducer}) => scrollNumReducer);
  const basicDrawerReducer = useSelector(({basicDrawerReducer}) => basicDrawerReducer);


  // OtherAboveFold
  const [bannerImg,  setBannerImg] = useState(bannerImg_1);

  const [innerContentHeight,  setInnerContentHeight] = useState(2120);
  const [innerContentPaddingTop,  setInnerContentPaddingTop] = useState(2120);
  const [svgWidth,  setSvgWidth] = useState(909.21);
  const [svgHeight,  setSvgHeight] = useState(199.69);
  const [otherMarginTitleBot,  setOtherMarginTitleBot] = useState(20.31);

  // 样式判断
  const normal = useMemo(() => {
    if(recReSizeReducer > 1920){
      setBannerImg(bannerImg_1);
      setInnerContentHeight(1885);
      setInnerContentPaddingTop(452);
      setOtherMarginTitleBot(20.31);
      setSvgWidth(1688);
      setSvgHeight(202.71);
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      setBannerImg(bannerImg_2);
      setInnerContentHeight(1497);
      setInnerContentPaddingTop(339);
      setOtherMarginTitleBot(14.7);
      setSvgWidth(1251);
      setSvgHeight(152.03);
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      setBannerImg(bannerImg_3);
      setInnerContentHeight(1122.75);
      setInnerContentPaddingTop(254.25);
      setOtherMarginTitleBot(11.03);
      setSvgWidth( 938.25);
      setSvgHeight(114.03);
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      setBannerImg(bannerImg_3);
      setInnerContentHeight(798.4);
      setInnerContentPaddingTop(180.08);
      setOtherMarginTitleBot(8.04);
      setSvgWidth(667.02);
      setSvgHeight(247.71);
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      setBannerImg(bannerImg_5);
      setInnerContentHeight(1440);
      setInnerContentPaddingTop(331);
      setOtherMarginTitleBot(32.67);
      setSvgWidth(638.27);
      setSvgHeight(247.71);
      return styles.normalSm;
    }
  }, [recReSizeReducer]);


  const transitionFed = 'all 1.8s';
  const opacityStart = 0;
  const opacityEnd = 1;
  const translateYStart = `translateY(${isMath(recReSizeReducer, 300)})`;
  const translateYEnd = `translateY(${isMath(recReSizeReducer, 0)})`;
  const translateYOtherEnd = `translateY(${isMath(recReSizeReducer, 50)})`;
  const translateScaleStart = `scale(1.5)`;
  const translateScaleEnd = `scale(1)`;

  // 背景透明度 start
  const initFedOpacityStart = {
    opacity: opacityStart,
    transition: transitionFed,
  };
  // 背景透明度 end


  // 位移加透明度 start
  const initFedStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateYStart,
  };

  const initFedScaleStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateScaleStart,
  };
  // 位移加透明度 end


   // TODO: onePage start
   const oneAnimatedScreenRef = useRef(null);
   const [oneAnimatedScreenFlag, setOneAnimatedScreenFlag] = useState(true);
   const [oneAnimatedScreenStyle, setOneAnimatedScreenStyleApi] = useState(initFedScaleStart);
   const oneAnimatedScreenScroll = () => {
        if (oneAnimatedScreenFlag) {
          setOneAnimatedScreenStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateScaleStart,
          });
        }else{
          setOneAnimatedScreenStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateScaleEnd,
          });
        }
    }
   // TODO: twoPage end
   
   // TODO: twoPage start
   const twoAnimatedContentRef = useRef(null);
   const [twoAnimatedContentFlag, setTwoAnimatedContentFlag] = useState(true);
   const [twoAnimatedContentStyle, setTwoAnimatedContentStyleApi] = useState(initFedStart);
   const twoAnimatedContentScroll = () => {
        if (twoAnimatedContentFlag) {
          setTwoAnimatedContentStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
        }else{
          setTwoAnimatedContentStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
        }
    }
   // TODO: twoPage end

   // TODO: threePage start
   const threeAnimatedOneRef = useRef(null);
   const threeAnimatedTwoRef = useRef(null);
   const threeAnimatedThreeRef = useRef(null);
   const [threeAnimatedOneStyle, setThreeAnimatedOneStyleApi] = useState(initFedStart);
   const [threeAnimatedTwoStyle, setThreeAnimatedTwoStyleApi] = useState(initFedStart);
   const [threeAnimatedThreeStyle, setThreeAnimatedThreeStyleApi] = useState(initFedStart);
   
  const threeAnimatedOneScroll = (curEle) => {
    let { isClientRect } = getClientRect(curEle, 700); // 当前元素
      if (isClientRect) {
        setThreeAnimatedOneStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setThreeAnimatedOneStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }
  const threeAnimatedTwoScroll = (curEle) => {
    let { isClientRect } = getClientRect(curEle, 700); // 当前元素
      if (isClientRect) {
        setThreeAnimatedTwoStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setThreeAnimatedTwoStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }
  const threeAnimatedThreeScroll = (curEle) => {
    let { isClientRect } = getClientRect(curEle, 700); // 当前元素
      if (isClientRect) {
        setThreeAnimatedThreeStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setThreeAnimatedThreeStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }


  const threeAnimateScroll = () => {
      if(recReSizeReducer > 750){
          // PC
          threeAnimatedOneScroll(threeAnimatedOneRef);
          threeAnimatedTwoScroll(threeAnimatedTwoRef);
          threeAnimatedThreeScroll(threeAnimatedThreeRef);
      }else{
          // H5
          threeAnimatedOneScroll(threeAnimatedOneRef);
          threeAnimatedTwoScroll(threeAnimatedTwoRef);
          threeAnimatedThreeScroll(threeAnimatedThreeRef);
      }
  }
  // TODO: threePage end

  // TODO: fourPage start
  const fourAnimatedChooseRef = useRef(null);
  const [fourAnimatedChooseStyle, setFourAnimatedChooseStyleApi] = useState(initFedStart);

  const fourAnimatedChooseScroll = (curEle) => {
    const num = recReSizeReducer > 750 ? 300 : 600;
    let { isClientRect } = getClientRect(curEle, num); // 当前元素
      if (isClientRect) {
        setFourAnimatedChooseStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setFourAnimatedChooseStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }

  const fourAnimateScroll = () => {
      if(recReSizeReducer > 750){
          // PC
          fourAnimatedChooseScroll(fourAnimatedChooseRef);
      }else{
          // H5
          fourAnimatedChooseScroll(fourAnimatedChooseRef);
      }
  }

   // TODO: fourPage end

   // TODO: fivesPage start
   const fivesAnimatedPointersRef = useRef(null);
   const [fivesAnimatedPointersStyle, setFivesAnimatedPointersStyleApi] = useState(initFedStart);
   const fivesAnimatedPointersScroll = (curEle) => {
    let { isClientRect } = getClientRect(curEle, 600); // 当前元素
      if (isClientRect) {
        setFivesAnimatedPointersStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setFivesAnimatedPointersStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }

  const fivesAnimateScroll = () => {
      if(recReSizeReducer > 750){
          // PC
          fivesAnimatedPointersScroll(fivesAnimatedPointersRef);
      }else{
          // H5
          fivesAnimatedPointersScroll(fivesAnimatedPointersRef);
      }
  }

   // TODO: fivesPage end

   // TODO: sixPage end
   const sixAnimatedServiceFlowRef = useRef(null);
   const [sixAnimatedServiceFlowStyle, setSixAnimatedServiceFlowStyleApi] = useState(initFedStart);

   const sixAnimatedServiceFlowScroll = (curEle) => {
      const num = recReSizeReducer > 750 ? 500 : 932;
      let { isClientRect } = getClientRect(curEle, num); // 当前元素
        if (isClientRect) {
          setSixAnimatedServiceFlowStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setSixAnimatedServiceFlowStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }
    const sixAnimateScroll = () => {
        if(recReSizeReducer > 750){
            // PC
            sixAnimatedServiceFlowScroll(sixAnimatedServiceFlowRef);
        }else{
            // H5
            sixAnimatedServiceFlowScroll(sixAnimatedServiceFlowRef);
        }
    }
   // TODO: sixPage end


   // TODO: sevenPage start
   const sevenAnimatedTitleRef = useRef(null);
   const sevenAnimatedDescRef = useRef(null);
   const sevenAnimatedChooseDestinatioRef = useRef(null);
   const sevenAnimatedSdLineRef = useRef(null);
   const sevenAnimatedGroupSelectCardRef = useRef(null);
   const sevenAnimatedGroupBtnRef = useRef(null);


   const [sevenAnimatedTitleStyle, setSevenAnimatedTitleStyleApi] = useState(initFedStart);
   const [sevenAnimatedDescStyle, setSevenAnimatedDescStyleApi] = useState(initFedStart);
   const [sevenAnimatedChooseDestinatioStyle, setSevenAnimatedChooseDestinatioStyleApi] = useState(initFedStart);
   const [sevenAnimatedSdLineStyle, setSevenAnimatedSdLineStyleApi] = useState(initFedStart);
   const [sevenAnimatedGroupSelectCardStyle, setSevenAnimatedGroupSelectCardStyleApi] = useState(initFedStart);
   const [sevenAnimatedGroupBtnStyle, setSevenAnimatedGroupBtnStyleApi] = useState(initFedStart);


   const sevenAnimatedTitleScroll = (curEle) => {
       let { isClientRect } = getClientRect(curEle); // 当前元素
       if (isClientRect) {
         setSevenAnimatedTitleStyleApi({
           opacity: opacityStart,
           transition: transitionFed,
           transform: translateYStart,
         });
         
       }else{
         setSevenAnimatedTitleStyleApi({
           opacity: opacityEnd,
           transition: transitionFed,
           transform: translateYEnd,
         });
         
       }
   }

   const sevenAnimatedDescScroll = (curEle) => {
     let { isClientRect } = getClientRect(curEle); // 当前元素
     if (isClientRect) {
       setSevenAnimatedDescStyleApi({
         opacity: opacityStart,
         transition: transitionFed,
         transform: translateYStart,
       });
       
     }else{
       setSevenAnimatedDescStyleApi({
         opacity: opacityEnd,
         transition: transitionFed,
         transform: translateYEnd,
       });
       
     }
   }

   const sevenAnimatedChooseDestinatioScroll = (curEle) => {
     let { isClientRect } = getClientRect(curEle); // 当前元素
     if (isClientRect) {
       setSevenAnimatedChooseDestinatioStyleApi({
         opacity: opacityStart,
         transition: transitionFed,
         transform: translateYStart,
       });
       
     }else{
       setSevenAnimatedChooseDestinatioStyleApi({
         opacity: opacityEnd,
         transition: transitionFed,
         transform: translateYEnd,
       });
       
     }
   }

   const sevenAnimatedSdLineScroll = (curEle) => {
     let { isClientRect } = getClientRect(curEle); // 当前元素
     if (isClientRect) {
       setSevenAnimatedSdLineStyleApi({
         opacity: opacityStart,
         transition: transitionFed,
         transform: translateYStart,
       });
       
     }else{
       setSevenAnimatedSdLineStyleApi({
         opacity: opacityEnd,
         transition: transitionFed,
         transform: translateYEnd,
       });
       
     }
   }

   const sevenAnimatedGroupSelectCardScroll = (curEle, num) => {
     let { isClientRect } = getClientRect(curEle, num); // 当前元素
     if (isClientRect) {
       setSevenAnimatedGroupSelectCardStyleApi({
         opacity: opacityStart,
         transition: transitionFed,
         transform: translateYStart,
       });
       
     }else{
       setSevenAnimatedGroupSelectCardStyleApi({
         opacity: opacityEnd,
         transition: transitionFed,
         transform: translateYEnd,
       });
       
     }
   }

   const sevenAnimatedGroupBtnScroll = (curEle) => {
     let { isClientRect } = getClientRect(curEle); // 当前元素
     if (isClientRect) {
       setSevenAnimatedGroupBtnStyleApi({
         opacity: opacityStart,
         transition: transitionFed,
         transform: translateYStart,
       });
       
     }else{
       setSevenAnimatedGroupBtnStyleApi({
         opacity: opacityEnd,
         transition: transitionFed,
         transform: translateYEnd,
       });
       
     }
   }

   const sevenAnimateScroll = () => {
       if(recReSizeReducer > 750){
           // PC
           sevenAnimatedTitleScroll(sevenAnimatedTitleRef);
           sevenAnimatedDescScroll(sevenAnimatedDescRef);
           sevenAnimatedChooseDestinatioScroll(sevenAnimatedChooseDestinatioRef);
           sevenAnimatedSdLineScroll(sevenAnimatedSdLineRef);
           sevenAnimatedGroupSelectCardScroll(sevenAnimatedGroupSelectCardRef);
           sevenAnimatedGroupBtnScroll(sevenAnimatedGroupBtnRef);
       }else{
           // H5
           sevenAnimatedTitleScroll(sevenAnimatedTitleRef);
           sevenAnimatedDescScroll(sevenAnimatedDescRef);
           sevenAnimatedChooseDestinatioScroll(sevenAnimatedChooseDestinatioRef);
           sevenAnimatedSdLineScroll(sevenAnimatedSdLineRef);
           sevenAnimatedGroupSelectCardScroll(sevenAnimatedGroupSelectCardRef, 600);
           sevenAnimatedGroupBtnScroll(sevenAnimatedGroupBtnRef);
       }
   }
   // TODO: sevenPage end
   

  useEffect(() => {
    setOneAnimatedScreenFlag(false);
    setTwoAnimatedContentFlag(false);

    delay(1000, () => {
      oneAnimatedScreenScroll();
      twoAnimatedContentScroll();
    });
    
  }, [oneAnimatedScreenFlag, twoAnimatedContentFlag]);
 

  useEffect(() => {
    oneAnimatedScreenScroll();
    threeAnimateScroll(); // threePage
    fourAnimateScroll(); // fourPage
    fivesAnimateScroll(); // fivesPage
    sixAnimateScroll(); // sixPage
    sevenAnimateScroll(); // sevenPage
  }, [scrolVal]);


  const { bannerData, pointersContentData, chooseData, pointersData, serviceFlowData } = customTravel;

  const isDesc = recReSizeReducer <= 750 ? (isNormalZhEnCss(lang, 'English') ? 'descEn' : 'desc') : 'desc';
  return (
      <div className={normal}>
        <div 
          className="onePage"
          ref={oneAnimatedScreenRef}
          style={oneAnimatedScreenStyle}
        >
          <OtherAboveFold
              config={{
                bgImg: bannerImg,
                svgTitle: recReSizeReducer <= 750 ? svgTitleM : svgTitle,
                title: bannerData.customTravel,
                innerContentStyles: {
                  width: `100%`,
                  height: isMath(recReSizeReducer,innerContentHeight),
                  paddingTop: isMath(recReSizeReducer,innerContentPaddingTop),
                },
                otherStyle: {
                  svgTitleCss: {
                    width: isMath(recReSizeReducer,svgWidth),
                    height: isMath(recReSizeReducer,svgHeight),
                    margin: `0 auto ${isMath(recReSizeReducer,otherMarginTitleBot)} auto`,
                  }
                }
              }}
          />
        </div>
        <div 
          className="twoPage"
          ref={twoAnimatedContentRef}
          style={twoAnimatedContentStyle}
        >
          <div 
            className="customizeTravelBtn" 
            style={{visibility: 'hidden'}}
          >
            <CustomizeTravelBtnOther
                config={{
                  title: '制定旅行',
                  handleEvent: () => {
                    dispatch(basicDrawerEvent({
                      visible: TYPES.DRAWERSHOW,
                      options: {
                        type: TYPES.customTravel,
                        status: 0,
                      },
                    }));
                  }
                }}
            />
          </div>
          <div className={isDesc}>
            <h4 className="titleText">{bannerData.tailorMade.title}</h4>
            <p className="titleSubText">{bannerData.tailorMade.desc}</p>
          </div>
        </div>
        <div className="threePage">
          <PointersCard
              config={{
                refs: {
                  innerOneRef: {
                    innerRef: threeAnimatedOneRef,
                    innerStyles: threeAnimatedOneStyle,
                  },
                  innerTwoRef: {
                    innerRef: threeAnimatedTwoRef,
                    innerStyles: threeAnimatedTwoStyle,
                  },
                  innerThreeRef: {
                    innerRef: threeAnimatedThreeRef,
                    innerStyles: threeAnimatedThreeStyle,
                  },
                },
                data: pointersContentData
              }}
          />
        </div>
        <div 
          className="fourPage"
          ref={fourAnimatedChooseRef}
          style={fourAnimatedChooseStyle}
        >
          <Choose
              config={{
                data: chooseData
              }}
          />
        </div>
        <div 
          className="fivesPage"
          ref={fivesAnimatedPointersRef}
          style={fivesAnimatedPointersStyle}
        >
          <Pointers
              config={{
                data: pointersData
              }}
          />
        </div>
        <div 
          className="sixPage"
          ref={sixAnimatedServiceFlowRef}
          style={sixAnimatedServiceFlowStyle}
        >
          <ServiceFlow
              config={{
                data: serviceFlowData
              }}
          />
        </div>
        <div className="sevenPage">
          <PlanTravel
            config={{
              getRefs: {
                innerTitleRef: sevenAnimatedTitleRef,
                innerDescRef: sevenAnimatedDescRef,
                innerChooseDestinatioRef: sevenAnimatedChooseDestinatioRef,
                innerSdLineRef: sevenAnimatedSdLineRef,
                innerGroupSelectCardRef: sevenAnimatedGroupSelectCardRef,
                innerGroupBtnRef: sevenAnimatedGroupBtnRef,
                innerTitleStyles: sevenAnimatedTitleStyle,
                innerDescStyles: sevenAnimatedDescStyle,
                innerChooseDestinatioStyles: sevenAnimatedChooseDestinatioStyle,
                innerChooseSdLineStyles: sevenAnimatedSdLineStyle,
                innerGroupSelectCardStyles: sevenAnimatedGroupSelectCardStyle,
                innerGroupBtnStyles: sevenAnimatedGroupBtnStyle,
              },
              status: 1,
            }}
          />
        </div>
      </div>
  );
});
export default Index;
